class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    // PBK: 閉じアニメの再生中は open 属性がまだ残っているため素の判定では「閉じる」に流れる。
    // 閉じかけをもう一度押した操作は「開き直す」と解釈する（open() 側でアニメを打ち切る）
    if (this.classList.contains('pbk-search--closing')) {
      this.open(event);
      return;
    }
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    // PBK: 閉じアニメの再生中に開き直された場合はアニメを打ち切る（クラスを外すと
    // 進行中の animationend ハンドラは finish 側のガードで無効化される）
    this.cancelPbkCloseAnimation();

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    // PBK: 検索モーダル（.pbk-search）だけは、開くときの animateMenuOpen の逆再生を
    // 待ってから実際に閉じる。<details> は open 属性が外れた瞬間に中身が消えて
    // CSS アニメが走らないため、閉じる前にクラスを付けてアニメを挟む。
    // 閉じる経路（× / summary / ESC / 外側クリック）は全てこの close() を通る。
    if (this.shouldAnimatePbkClose()) {
      this.playPbkCloseAnimation(focusToggle);
      return;
    }
    this.finalizeClose(focusToggle);
  }

  shouldAnimatePbkClose() {
    if (!this.classList.contains('pbk-search')) return false;
    if (!this.isOpen()) return false;
    if (this.classList.contains('pbk-search--closing')) return false; // 二重呼び出し（アニメ中の再クリック等）は無視
    if (!this.querySelector('.search-modal')) return false;
    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  playPbkCloseAnimation(focusToggle) {
    const modal = this.querySelector('.search-modal');
    this.classList.add('pbk-search--closing');

    const finish = () => {
      // open() でキャンセルされていたら閉じない
      if (!this.classList.contains('pbk-search--closing')) return;
      clearTimeout(this.pbkCloseTimer);
      this.pbkCloseTimer = null;
      modal.removeEventListener('animationend', onAnimationEnd);
      this.classList.remove('pbk-search--closing');
      this.finalizeClose(focusToggle);
    };
    const onAnimationEnd = (event) => {
      if (event.target === modal) finish();
    };

    modal.addEventListener('animationend', onAnimationEnd);
    // animationend が来ないケース（背面タブ・アニメ未適用）に備えた保険
    this.pbkCloseTimer = setTimeout(finish, 400);
  }

  cancelPbkCloseAnimation() {
    if (this.pbkCloseTimer) {
      clearTimeout(this.pbkCloseTimer);
      this.pbkCloseTimer = null;
    }
    this.classList.remove('pbk-search--closing');
  }

  finalizeClose(focusToggle = true) {
    // アニメを経由せず直接閉じた経路（アニメ中の × 再クリック等）でもクラス／タイマーを残さない
    this.cancelPbkCloseAnimation();
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
